import { Plug } from "lucide-mui";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import HubSpotLogo from "./HubSpotLogo.tsx";

/**
 * Brand mark for a CRM provider id (`crm_connections.provider`). Unknown
 * providers fall back to a neutral plug so a new provider still renders.
 */
export default function CrmProviderLogo({
  provider,
  ...props
}: SvgIconProps & { provider: string }) {
  if (provider === "hubspot") return <HubSpotLogo {...props} />;
  return <Plug {...props} />;
}
